import CustomPopover from "@com/components/custom-popover/index.vue";
import { computed, defineComponent } from "vue";
import { filterSchemaConfig } from "@pt/views/pt-entry/components/filter-bar/filter-model";
import i18n from "@/lang";
export default defineComponent({
    components: {
        CustomPopover: CustomPopover
    },
    props: {
        model: Object
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var label = i18n.t("resourceManager.filter.duration");
        var popoverSchema = [
            [
                filterSchemaConfig.duration_min,
                {
                    label: "-"
                },
                filterSchemaConfig.duration_max,
                filterSchemaConfig.duration_unit, 
            ], 
        ];
        var durationPopoverConfig = {
            width: 300
        };
        var durationSelectedValue = computed(function() {
            var min = props.model.duration_min;
            var max = props.model.duration_max;
            var unit = props.model.duration_unit;
            var value = "";
            var unitMap = {
                sec: "s",
                min: "m",
                hour: "h"
            };
            var activeUnit = unitMap[unit];
            if (min || max) {
                if (min) {
                    value = "".concat(min).concat(activeUnit, "\u2264") + value;
                }
                value += i18n.t("resourceManager.filter.duration");
                if (max) {
                    value = value + "\u2264".concat(max).concat(activeUnit, " ");
                }
                return [
                    {
                        label: value,
                        value: "time"
                    }, 
                ];
            }
            return [];
        });
        var handleChange = function(value) {
            emit("change", value);
        };
        var clearValue = [
            {
                prop: "duration_min",
                value: 0
            },
            {
                prop: "duration_max",
                value: 0
            },
            {
                prop: "duration_unit",
                value: "sec"
            }, 
        ];
        var deleteTag = function(tag) {
            emit("change", clearValue);
        };
        var handleClearClick = function(event) {
            emit("change", clearValue);
        };
        return {
            label: label,
            durationPopoverConfig: durationPopoverConfig,
            popoverSchema: popoverSchema,
            durationSelectedValue: durationSelectedValue,
            handleChange: handleChange,
            deleteTag: deleteTag,
            handleClearClick: handleClearClick
        };
    }
});
